module.exports = __webpack_public_path__ + "static/media/phillip.8deefd5b.svg";